module.exports = __webpack_public_path__ + "img/noc-hero.8857d44f.jpg";